import React, { useState } from 'react'
import "./support.scss"
import { Link } from 'react-router-dom';

const Accordion = ({ title, content, index, activeIndex, setActiveIndex }) => {
    // const [isOpen, setIsOpen] = useState(false);

    // const toggleAccordion = () => {
    //     setIsOpen(!isOpen);
    // };
    const isOpen = index === activeIndex;

    const toggleAccordion = () => {
        setActiveIndex(isOpen ? null : index);
    };

    return (
        <div className="accordion">
            <div className="accordion-header" onClick={toggleAccordion} style={{ cursor: 'pointer' }}>
                <h3 className='accordion-heading'>{title}</h3>
                <span className="accordion-icon">{isOpen ? '-' : '+'}</span>
            </div>
            {isOpen && <div className="accordion-content">{content}</div>}
        </div>
    );
};

function Support() {
    const handleEmailClick = () => {
        window.location.href = 'mailto:googlereviews@iTester.com';
    };
    const [activeIndex, setActiveIndex] = useState(null);
    return (
        <div className='support-page'>
            <div className="support-container">
                <h6 className='heading'>Support</h6>
                <div className="row">
                    <div className="col-12">
                        <div className="support-card">
                            <p className='mb-0'>Need help? Contact us at <Link className='mail-link' to="mailto:support@goodreviews.co">support@goodreviews.co</Link> for support.</p>
                        </div>
                    </div>
                </div>
                <div className="row justify-content-center">
                    <div className="col-12">
                        <h6 className='heading pt-3'>FAQ’s (Frequrently Asked Questions)</h6>
                        <div className="support-card ps-lg-5">
                            <Accordion
                                title="1. What is Good Reviews?"
                                content="Good Reviews is a platform that helps collect authentic positive reviews and user-generated content to build customer confidence."
                                index={0}
                                activeIndex={activeIndex}
                                setActiveIndex={setActiveIndex}
                            />
                            <Accordion
                                title="2. How does Good Reviews benefit your business?"
                                content="By collecting authentic positive reviews and user-generated content, Good Reviews helps build customer confidence, establishes credibility, and encourages potential buyers to engage with your business."
                                index={1}
                                activeIndex={activeIndex}
                                setActiveIndex={setActiveIndex}
                            />
                            <Accordion
                                title="3. What industries does Good Reviews support?"
                                content={
                                    <>
                                        <p>Good Reviews serves a variety of industries, including but not limited to:</p>
                                        <ul className="accordion-list-style">
                                            <li><p>Automotive Services</p></li>
                                            <li><p>Beauty and Wellness</p></li>
                                            <li><p>Education and Childcare</p></li>
                                            <li><p>Gym and Fitness</p></li>
                                            <li><p>Healthcare Providers</p></li>
                                            <li><p>Home Improvement</p></li>
                                            <li><p>Real Estate</p></li>
                                            <li><p>Restaurants and Dining</p></li>
                                            <li><p>Retail Stores</p></li>
                                            <li><p>Travel and Hospitality</p></li>
                                        </ul>
                                    </>
                                }
                                index={2}
                                activeIndex={activeIndex}
                                setActiveIndex={setActiveIndex}
                            />
                            <Accordion
                                title="4. How do I set up my Google Business Profile?"
                                content="Good Reviews provides guidance and tools to help
                                    you set up and optimize your Google Business Profile, making it easier to attract
                                    and engage customers."
                                index={3}
                                activeIndex={activeIndex}
                                setActiveIndex={setActiveIndex}
                            />
                            <Accordion
                                title="5. Can I collect reviews from multiple platforms?"
                                content="Yes! Good Reviews allows you to collect and
                                    manage reviews from various platforms, including Google, Yelp, Facebook, TripAdvisor, and more, all
                                    in one place."
                                index={4}
                                activeIndex={activeIndex}
                                setActiveIndex={setActiveIndex}
                            />
                            <Accordion
                                title="6. What is the pricing for Good Reviews?"
                                content="Good Reviews offers a variety of pricing plans,
                                    including a free trial to get started. For specific pricing details, please visit
                                    the Pricing section on their website."
                                index={5}
                                activeIndex={activeIndex}
                                setActiveIndex={setActiveIndex}
                            />
                            <Accordion
                                title="7. Is there a demo available?"
                                content="Yes, you can book a demo to see how Good Reviews
                                    can benefit your business. Visit their website to schedule a demonstration."
                                index={6}
                                activeIndex={activeIndex}
                                setActiveIndex={setActiveIndex}
                            />
                            <Accordion
                                title="8. How do I start my free trial?"
                                content="To start your free 7-day trial, simply visit the
                                    Good Reviews website and follow the prompts to sign up."
                                index={7}
                                activeIndex={activeIndex}
                                setActiveIndex={setActiveIndex}
                            />
                            <Accordion
                                title="9. What kind of support does Good Reviews provide?"
                                content="Good Reviews offers excellent customer support to
                                    assist you with any questions or issues you may encounter while using the platform."
                                index={8}
                                activeIndex={activeIndex}
                                setActiveIndex={setActiveIndex}
                            />
                            <Accordion
                                title="10. How can I contact Good Reviews?"
                                content={
                                    <>
                                        You can reach out to Good Reviews via phone at
                                        <Link to="tel:1-855-834-2399" className="accordion-link"> 1 (855) 834-2399</Link> or
                                        through email at
                                        <Link to="mailto:hello@goodreviews.co" className="accordion-link"> hello@goodreviews.co</Link>.
                                        Their office is located at 447 Broadway, 2nd Floor, New York, NY 10013, USA.
                                    </>
                                }
                                index={9}
                                activeIndex={activeIndex}
                                setActiveIndex={setActiveIndex}
                            />

                        </div>
                    </div>
                </div>
            </div>
        </div >
    )
}

export default Support
